import React from 'react';

/**
 * Заглушка для index route /chats — показывается,
 * когда не выбран конкретный чат.
 * Список чатов рендерится в ChatsLayout (левая панель).
 * CSS подключается в ChatsLayout.jsx.
 */
export default function ChatsPage() {
    return (
        <div className="chats-layout__placeholder">
            <div className="chats-layout__placeholder-icon">💬</div>
            <div className="chats-layout__placeholder-text">
                Выберите чат, чтобы начать общение
            </div>
        </div>
    );
}
